import { useState } from 'react';

const faqs = [
  {
    q: 'Was ist ein OOPBUY Spreadsheet?',
    a: 'Ein OOPBUY Spreadsheet ist eine strukturierte Produktübersicht, die verschiedene Artikel aus unterschiedlichen Kategorien auflistet. Es hilft Käufern, Produkte schneller zu finden, Preise zu vergleichen und fundierte Kaufentscheidungen zu treffen. Das Spreadsheet wird regelmäßig aktualisiert und enthält nützliche Zusatzinformationen wie Produktbewertungen und Versanddetails.',
  },
  {
    q: 'Ist das OOPBUY Spreadsheet kostenlos?',
    a: 'Ja, das OOPBUY Spreadsheet ist eine kostenlose Ressource für alle Nutzer. Es wurde erstellt, um den Einkaufsprozess für deutsche Käufer zu vereinfachen und transparente Produktinformationen bereitzustellen. Es gibt keine versteckten Kosten oder Abonnementgebühren.',
  },
  {
    q: 'Ist OOPBUY sicher in der Nutzung?',
    a: 'OOPBUY selbst ist eine Plattform, die als Vermittler zwischen Käufern und Verkäufern fungiert. Bei richtiger Nutzung – mit sicheren Passwörtern, geschützten Zahlungsmethoden und der Beachtung von Datenschutzrichtlinien – ist die Nutzung sicher. Das Spreadsheet dient ausschließlich als Informationsquelle und greift nicht in den Bestellprozess ein.',
  },
  {
    q: 'Wie funktioniert OOPBUY mit dem Spreadsheet?',
    a: 'Das OOPBUY Spreadsheet dient als Navigationshilfe. Nutzer durchsuchen die kategorisierten Produktlisten, finden interessante Artikel und können über die bereitgestellten Links direkt zu den entsprechenden Produktseiten navigieren. Das Spreadsheet selbst ist kein Shop, sondern ein strukturiertes Nachschlagewerk.',
  },
  {
    q: 'Wie finde ich die besten Produkte mit dem Spreadsheet?',
    a: 'Nutze die Kategorie-Filter, um gezielt nach Produkttypen zu suchen. Vergleiche die aufgelisteten Artikel anhand von Beschreibungen und Bewertungen. Für Anfänger empfehlen wir, mit den beliebtesten Kategorien wie Sneaker oder Streetwear zu beginnen und sich dann schrittweise durch das Angebot zu arbeiten.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            Häufig gestellte Fragen zum <strong>OOPBUY Spreadsheet</strong>
          </h2>
          <div className="w-12 h-0.5 bg-primary-400 mx-auto"></div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-foreground-400 transition-transform duration-200 text-base ${
                      openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <div className="pt-0 border-t border-background-200/40">
                    <p className="text-sm text-foreground-600 leading-relaxed pt-3">
                      {faq.a}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}